/**
 * AWIN Affiliate Tracking Utilities
 * Merchant ID: 124052
 */

/**
 * Reads the awc affiliate click ID from the cookie set on landing.
 */
export const getAwcFromCookie = () => {
  const match = document.cookie.match(/(^|;)\s*awc=([^;]+)/);
  return match ? match[2] : '';
};

/**
 * Fires the AWIN conversion pixel and sets the AWIN.Tracking.Sale object.
 *
 * @param {object} params
 * @param {string|number} params.orderRef       - Unique order/session reference
 * @param {string|number} params.orderSubtotal  - Order amount (e.g. 19.95)
 * @param {string}        params.currencyCode   - ISO currency code (e.g. 'EUR', 'GBP')
 * @param {string}        [params.commissionGroup='Sale'] - AWIN commission group
 * @param {string|number} [params.saleAmount]   - Sale amount (defaults to orderSubtotal)
 * @param {string}        [params.voucherCode]  - Voucher/promo code if any
 * @param {string}        [params.customerAcquisition='NEW'] - 'NEW' or 'EXISTING'
 */
export const fireAwinConversion = ({
  orderRef,
  orderSubtotal,
  currencyCode,
  commissionGroup = 'Sale',
  saleAmount,
  voucherCode = '',
  customerAcquisition = 'NEW',
}) => {
  const amount = String(orderSubtotal);
  const currency = currencyCode.toUpperCase();
  const sale = saleAmount !== undefined ? String(saleAmount) : amount;
  const parts = `${commissionGroup}:${sale}`;

  // Set AWIN Tracking Sale object (Example #2 - SPA/AJAX pattern)
  if (typeof window.AWIN !== 'undefined' && typeof window.AWIN.Tracking !== 'undefined') {
    window.AWIN.Tracking.Sale = {};
    window.AWIN.Tracking.Sale.amount = amount;
    window.AWIN.Tracking.Sale.channel = 'aw';
    window.AWIN.Tracking.Sale.orderRef = String(orderRef);
    window.AWIN.Tracking.Sale.parts = parts;
    window.AWIN.Tracking.Sale.currency = currency;
    window.AWIN.Tracking.Sale.voucher = voucherCode;
    window.AWIN.Tracking.Sale.test = '0';
    window.AWIN.Tracking.run();
  }

  // Fire fall-back conversion pixel (client-side)
  const img = new Image();
  img.width = 0;
  img.height = 0;
  img.border = '0';
  img.src =
    `https://www.awin1.com/sread.img?tt=ns&tv=2&merchant=124052` +
    `&amount=${amount}&cr=${currency}&ref=${orderRef}` +
    `&parts=${parts}&vc=${voucherCode}` +
    `&ch=aw&customeracquisition=${customerAcquisition}`;
  document.body.appendChild(img);

  // Fire Server-to-Server pixel via Netlify Edge Function
  fetch('/api/awin-s2s', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      orderRef,
      orderSubtotal,
      currencyCode,
      commissionGroup,
      saleAmount,
      voucherCode,
      awc: getAwcFromCookie(),
      testmode: '0',
    }),
  }).catch(() => {});
};
